import { IconButton, Tooltip } from "@mui/material";
import { EyeIcon } from "../../../components/Icons";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import HeaderColumn from "../components/HeaderColumn";
import CambiosEvento from "./CambiosEvento";

const { handlerModal } = useGeneralAppStore.getState();

export const userActasTableData = (
  data,
  getEventSelect,
  getActaDetalle,
  setFiltersField,
  setOrder,
  setOrderField
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"email"}
            place={"Email"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <Tooltip
            title={`ID Usuario: ${params.row?.causer?.usuarioID}`}
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
            arrow
          >
            <span>{params.value}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"numero_acta"}
            place={"N° Acta"}
          />
        );
      },
      renderCell: (params) => {
        // console.log(params);
        
        return (
          <span
            className="text-primary fw-bold"
            onClick={() => {
              getActaDetalle(params.row.id_subject);
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: "properties",
      headerName: "Cambios",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <CambiosEvento params={params} />
          </>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Fecha",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"created_at"}
            place={"Fecha"}
          />
        );
      },
    },
    {
      field:"acciones",
      headerName: "Acciones",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <Tooltip
            title="Ver detalle"
            arrow
            className="mx-auto"
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
          >
            <IconButton
              onClick={() => {
                getEventSelect(params.id);
              }}
            >
              <EyeIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    // causer: {id, usuarioID, documento, nombre, genero, celular, correo};
    // created_at: "27/06/2024 16:19:54";
    // id: 8;
    // log_name: "user";
    // subject: {id: 1, numero_acta: 1234};
    return {
      causer: d.causer,
      email: d.causer?.correoElectronico,
      created_at: d.created_at,
      id: d.id,
      log_name: d?.log_name,
      id_subject: d.subject?.id,
      numero_acta: d.subject?.numero_acta,
      properties: d.properties,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.causer?.correoElectronico)?.toString().toLowerCase().includes(value) ||
      String(d.log_name)?.toString().toLowerCase().includes(value) ||
      String(d.id_subject)?.toString().toLowerCase().includes(value) ||
      String(d.subject?.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};

export const userActasAnuladastableData = (
  data,
  getEventSelect,
  getActaDetalle,
  setFiltersField,
  setOrder,
  setOrderField
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"email"}
            place={"Email"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <Tooltip
            title={`ID Usuario: ${params.row.causer.usuarioID}`}
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
            arrow
          >
            <span>{params.value}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"numero_acta"}
            place={"N° Acta"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <span
            className="text-primary fw-bold"
            onClick={() => {
              getActaDetalle(params.row.id_subject);
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: "motivo",
      headerName: "Motivo",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"motivo"}
            place={"Motivo"}
          />
        );
      },
    },
    {
      field: "created_at",
      headerName: "Fecha",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"created_at"}
            place={"Fecha"}
          />
        );
      },
    },
    {
      headerName: "Acciones",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <Tooltip
            title="Ver detalle"
            arrow
            className="mx-auto"
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
          >
            <IconButton
              onClick={() => {
                getEventSelect(params.id);
              }}
            >
              <EyeIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    // causer: {id, usuarioID, documento, nombre, genero, celular, correo};
    // created_at: "27/06/2024 16:19:54";
    // id: 8;
    // log_name: "user";
    // subject: {id: 1, numero_acta: 1234, motivo: "No es infraccion"};
    return {
      causer: d.causer,
      email: d.causer?.correoElectronico,
      created_at: d.created_at,
      id: d.id,
      log_name: d?.log_name,
      id_subject: d.subject.id,
      motivo: d.subject?.motivo,
      numero_acta: d.subject?.numero_acta,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.causer?.correoElectronico)?.toString().toLowerCase().includes(value) ||
      String(d.log_name)?.toString().toLowerCase().includes(value) ||
      String(d.id_subject)?.toString().toLowerCase().includes(value) ||
      String(d.motivo)?.toString().toLowerCase().includes(value) ||
      String(d.subject?.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};

export const errorLogsTableData = (
  data,
  getEventSelect,
  setFiltersField,
  setOrder,
  setOrderField
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"email"}
            place={"Email"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <Tooltip
            title={`ID Usuario: ${params.row?.causer?.usuarioID}`}
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
            arrow
          >
            <span>{params.value}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "descripcion",
      headerName: "Descripción",
      flex: 1.5,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"description"}
            place={"Descripción"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <Tooltip
            title={`${params.value}`}
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
            arrow
          >
            <span>{params.value}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Fecha",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"created_at"}
            place={"Fecha"}
          />
        );
      },
    },
    {
      headerName: "Acciones",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <Tooltip
            title="Ver detalle"
            arrow
            className="mx-auto"
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
          >
            <IconButton
              onClick={() => {
                getEventSelect(params.id);
              }}
            >
              <EyeIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    // causer: {id, usuarioID, documento, nombre, genero, celular, correo};
    // created_at: "27/06/2024 16:19:54";
    // id: 8;
    // desciption: "algo";
    return {
      causer: d.causer,
      email: d.causer?.correoElectronico,
      created_at: d.created_at,
      id: d.id,
      descripcion: d?.description,
      numero_acta: d.subject?.numero_acta,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.causer?.correoElectronico)?.toString().toLowerCase().includes(value) ||
      String(d.description)?.toString().toLowerCase().includes(value) ||
      String(d.created_at)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};

export const jobsLogsTableData = (
  data,
  getEventSelect,
  getActaDetalle,
  setFiltersField,
  setOrder,
  setOrderField
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "descripcion",
      headerName: "Descripción",
      flex: 1,
      sortable: false,
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"numero_acta"}
            place={"N° Acta"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <span
            className="text-primary fw-bold"
            onClick={() => {
              getActaDetalle(params.row?.acta?.id);
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Fecha",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"created_at"}
            place={"Fecha"}
          />
        );
      },
    },
    // {
    //   headerName: "Acciones",
    //   width: 120,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return (
    //       <Tooltip
    //         title="Ver detalle"
    //         arrow
    //         className="mx-auto"
    //         slotProps={{
    //           tooltip: {
    //             sx: {
    //               backgroundColor: "#1134C9",
    //               color: "#fff",
    //               fontSize: "0.8rem",
    //               fontWeight: "600",
    //             },
    //           },
    //           arrow: {
    //             sx: {
    //               color: "#1134C9",
    //             },
    //           },
    //         }}
    //       >
    //         <IconButton
    //           onClick={() => {
    //             getEventSelect(params.id);
    //           }}
    //         >
    //           <EyeIcon />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // },
  ];

  const rows = data.map((d, index) => {
    // causer: {id, usuarioID, documento, nombre, genero, celular, correo};
    // created_at: "27/06/2024 16:19:54";
    // id: 8;
    // desciption: "algo";
    return {
      acta: d?.acta,
      created_at: d.created_at,
      id: d.id,
      descripcion: d?.description,
      numero_acta: d.acta?.numero_infraccion,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.acta?.numero_infraccion)?.toString().toLowerCase().includes(value) ||
      String(d.description)?.toString().toLowerCase().includes(value) ||
      String(d.created_at)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};

export const totalAuditsActaTableData = (
  data,
  getEventSelect,
  setFiltersField,
  setOrder,
  setOrderField
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"email"}
            place={"Email"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <Tooltip
            title={`ID Usuario: ${params.row?.causer?.usuarioID}`}
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
            arrow
          >
            <span>{params.value}</span>
          </Tooltip>
        );
      },
    },
    {
      field: "description",
      headerName: "Descripción",
      flex: 1.5,
      sortable: false,
    },
    {
      field: "properties",
      headerName: "Cambios",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <CambiosEvento params={params} />
          </>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Fecha",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"created_at"}
            place={"Fecha"}
          />
        );
      },
    },
    {
      headerName: "Acciones",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <Tooltip
            title="Ver detalle"
            arrow
            className="mx-auto"
            slotProps={{
              tooltip: {
                sx: {
                  backgroundColor: "#1134C9",
                  color: "#fff",
                  fontSize: "0.8rem",
                  fontWeight: "600",
                },
              },
              arrow: {
                sx: {
                  color: "#1134C9",
                },
              },
            }}
          >
            <IconButton
              onClick={() => {
                getEventSelect(params.id);
              }}
            >
              <EyeIcon />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const rows = data.map((d, index, data) => {
    // causer: {id, usuarioID, documento, nombre, genero, celular, correo};
    // created_at: "27/06/2024 16:19:54";
    // id: 8;
    // log_name: "user";
    // subject: {id: 1, numero_acta: 1234};
    return {
      causer: d.causer,
      email: d.causer?.correoElectronico,
      created_at: d.created_at,
      description: d.description,
      id: d.id,
      log_name: d?.log_name,
      id_subject: d.subject?.id,
      numero_acta: d.subject?.numero_acta,
      properties: d.properties,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.causer?.correoElectronico)?.toString().toLowerCase().includes(value) ||
      String(d.log_name)?.toString().toLowerCase().includes(value) ||
      String(d.id_subject)?.toString().toLowerCase().includes(value) ||
      String(d.subject?.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};

export const totalAuditsUsuarioTableData = (
  data,
  getEventSelect,
  getActaDetalle,
  setFiltersField,
  setOrder,
  setOrderField
) => {
  const columns = [
    { field: "id", headerName: "ID", hide: false },
    {
      field: "subject_type",
      headerName: "Sujeto",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"subject_type"}
            place={"Sujeto"}
          />
        );
      },
    },
    {
      field: "numero_acta",
      headerName: "Acta",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"numero_acta"}
            place={"N° Acta"}
          />
        );
      },
      renderCell: (params) => {
        return (
          <span
            className="text-primary fw-bold"
            onClick={() => {
              getActaDetalle(params.row?.id_subject);
            }}
          >
            {params.value}
          </span>
        );
      },
    },
    {
      field: "properties",
      headerName: "Cambios",
      flex: 3,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <CambiosEvento params={params} />
          </>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Fecha",
      flex: 1,
      sortable: false,
      renderHeader: () => {
        return (
          <HeaderColumn
            setFiltersField={setFiltersField}
            setOrder={setOrder}
            setOrderField={setOrderField}
            typeInput={"text"}
            field={"created_at"}
            place={"Fecha"}
          />
        );
      },
    },
    {
      headerName: "Acciones",
      width: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            <Tooltip
              title="Ver detalle"
              arrow
              className="mx-auto"
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "#1134C9",
                    color: "#fff",
                    fontSize: "0.8rem",
                    fontWeight: "600",
                  },
                },
                arrow: {
                  sx: {
                    color: "#1134C9",
                  },
                },
              }}
            >
              <IconButton
                disabled={
                  params.row?.event === "deleted" &&
                  params.row?.description === "Este modelo ha sido eliminado"
                }
                onClick={() => {
                  getEventSelect(params.id);
                }}
              >
                <EyeIcon />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const rows = data.map((d, index) => {
    // causer: {id, usuarioID, documento, nombre, genero, celular, correo};
    // created_at: "27/06/2024 16:19:54";
    // id: 8;
    // log_name: "user";
    // subject: {id: 1, numero_acta: 1234};
    return {
      data: d,
      causer: d.causer,
      email: d.causer?.correoElectronico,
      created_at: d.created_at,
      id: d.id,
      log_name: d?.log_name,
      id_subject: d.subject?.id,
      numero_acta: d.subject?.numero_acta ?? d.subject?.acta?.numero_infraccion,
      event: d?.event,
      description: d?.description,
      subject_type: d?.subject_type,
      subject: d?.subject,
      properties: d?.properties,
    };
  });

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.id)?.toString().toLowerCase().includes(value) ||
      String(d.causer?.correoElectronico)?.toString().toLowerCase().includes(value) ||
      String(d.log_name)?.toString().toLowerCase().includes(value) ||
      String(d.id_subject)?.toString().toLowerCase().includes(value) ||
      String(d.subject_type)?.toString().toLowerCase().includes(value) ||
      String(d.subject?.numero_acta)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
